import React, { useEffect, useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function Tickets() {
  const [height, setHeight] = useState(700);

  useEffect(() => {
    window.scrollTo(0, 0);
    const onMsg = (e) => {
      if (typeof e.data === "string" && e.data.indexOf("epicResize::") !== -1) {
        const h = parseInt(e.data.replace("epicResize::", ""), 10);
        if (!isNaN(h) && h > 200) setHeight(h + 40);
      }
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);

  return (
    <div className="bg-epic-black min-h-screen">
      <Navbar />
      <section id="tickets" data-testid="tickets-section" className="pt-32 md:pt-40 pb-24 md:pb-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <Reveal className="mb-10 md:mb-14">
            <Overline>Live At The Epic</Overline>
            <h1 className="font-display text-5xl md:text-7xl lg:text-8xl text-white leading-[0.9] mt-4">
              Purchase Tickets
            </h1>
            <p className="text-epic-gray text-base md:text-lg mt-5 max-w-2xl font-light">
              Browse upcoming shows and secure your seats. Tickets are powered by our secure ticketing partner.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="bg-epic-charcoal border border-white/5 p-2 md:p-6">
              <iframe
                title="The Epic Center Tickets"
                data-testid="ludus-widget"
                src="/ludus.html"
                className="w-full border-0"
                style={{ height: `${height}px`, width: "100%" }}
                loading="lazy"
              />
            </div>
            <p className="text-white/40 text-xs mt-4 text-center">
              Having trouble viewing tickets? Visit{" "}
              <a href="https://liveatepic.ludus.com" target="_blank" rel="noopener noreferrer" className="text-epic-gold hover:underline">
                liveatepic.ludus.com
              </a>
            </p>
          </Reveal>
        </div>
      </section>
      <Footer />
    </div>
  );
}
